import * as angular from 'angular';

class PlatformConfigurationComponentCtrl implements ng.IController {
    public platformConfig: TsoPlatformConfigurationDto;

    $onInit() {}
}

angular.module('app').component('pkpPlatformConfiguration', {
    controller: PlatformConfigurationComponentCtrl,
    template:
        require('app/operator-settings-general/platform-configuration.component.html'),
    bindings: {
        platformConfig: '<'
    }
});
